import { z } from 'zod';
const ALLOWED_MIME = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'];
const MAX_BYTES = 12 * 1024 * 1024;
export const photoUploadUrlSchema = z.object({
    contentType: z.enum(ALLOWED_MIME),
    sizeBytes: z.number().int().positive().max(MAX_BYTES),
});
export const photoConfirmSchema = z.object({
    objectKey: z.string().min(1).max(512),
    contentType: z.enum(ALLOWED_MIME),
    sizeBytes: z.number().int().positive().max(MAX_BYTES),
});
export const photoDeleteSchema = z.object({
    objectKey: z.string().min(1).max(512),
});
/** New ordering — must be a permutation of the entity's current photo keys. */
export const photoReorderSchema = z.object({
    orderedKeys: z.array(z.string().min(1).max(512)).min(1).max(100),
});
//# sourceMappingURL=photo.js.map